module.exports = __webpack_public_path__ + "static/media/hip-quizz.55f94807.jpg";